/**
 * custom.js — JavaScript maison (LABO DU CHEF)
 * ===========================================================================
 * Fichier AJOUTÉ par nous, absent du thème Impact d'origine (Maestrooo).
 * Il n'est donc pas écrasé par une mise à jour de l'éditeur : seule la balise
 * qui l'appelle dans layout/theme.liquid est à réinjecter après une mise à jour.
 *
 * ⚠️ CE FICHIER PORTE TROIS MODULES INDÉPENDANTS, DE NATURES DIFFÉRENTES :
 *
 *   MODULE 1 — Francisation des textes de l'app de réservation : la grille
 *              de l'accueil ET la modale de réservation des fiches produit.
 *              CORRECTIF TEMPORAIRE, à retirer quand Servicify corrigera.
 *              Cosmétique : sa disparition ne casse aucune vente.
 *
 *   MODULE 2 — Option « Offrir » : champs du destinataire du cadeau.
 *              PERMANENT et CRITIQUE : sans lui, sur les fiches cours et
 *              ateliers, le message cadeau du client est perdu, et les
 *              coordonnées d'un destinataire décoché partent dans la commande.
 *
 *   MODULE 3 — Cartes produit : liste des prochaines dates et places
 *              restantes, lues dans l'app de réservation ; un clic ouvre la
 *              réservation sur la date. PERMANENT. Sans lui, les cartes restent
 *              utilisables mais sans dates, sans pastilles et sans « Complet ».
 *
 * ⚠️ Le jour où Servicify corrige, on supprime LE MODULE 1, PAS CE FICHIER.
 * Supprimer le fichier — ou sa balise dans layout/theme.liquid — ferait revenir
 * ces défauts d'un coup, en silence, et laisserait les champs « Offrir »
 * visibles en permanence.
 *
 * ===========================================================================
 * MODULE 1 — Francisation des textes de l'app de réservation
 * ===========================================================================
 *
 * Tâche Asana « DEV » (1217939232354789), sous-tâche 1 — retours du 28/08/2026.
 *
 * ── POURQUOI CE FICHIER EXISTE ─────────────────────────────────────────────
 *
 * Deux chaînes anglaises s'affichent dans la grille de l'app Easy Appointment
 * Booking. Elles ne sont PAS traduisibles : elles sont écrites en dur dans le
 * bundle de l'app (embedInit.js, ~offset 892736), sans passer par son système
 * de libellés. Vérifié dans le code :
 *
 *   _ && d("div", null, e.duration, " minutes"),
 *   b && d("div", null, "From ", formatPriceWithCurrency(...)),
 *   k && ... ? d("div", null, "Up to ", h, " attendees per timeslot") : null
 *
 * La ligne suivante, elle, rend le CTA par getDisplaySettingValue(...) — d'où
 * un bouton correctement en français. C'est la ligne de partage : ce qui passe
 * par ce système est traduisible, le reste ne l'est pas.
 *
 * Le bundle appartient à l'éditeur et n'est pas modifiable. Mais la grille rend
 * en LIGHT DOM (Preact + styled-components), pas en Shadow DOM — c'est ce qui
 * permet déjà à custom.css de la restyler. On peut donc aussi la relire et la
 * réécrire. C'est ce que fait ce fichier.
 *
 * ── LA STRUCTURE RÉELLE DU DOM, ET LA LEÇON QUI VA AVEC ────────────────────
 *
 * ⚠️ Chaque ligne est bien rendue dans son propre <div>, MAIS PAS DANS UN SEUL
 * NŒUD DE TEXTE. Preact crée un nœud par argument passé au composant. Relire
 * les appels ci-dessus donne directement le découpage :
 *
 *   <div>From €79.00</div>                    →  ["From ", "€79.00"]
 *   <div>Up to 6 attendees per timeslot</div> →  ["Up to ", "6", " attendees per timeslot"]
 *   <div>120 minutes</div>                    →  ["120", " minutes"]
 *
 * Une première version de ce fichier ancrait ses motifs (^…$) sur la ligne
 * entière, en supposant un nœud par ligne. Résultat mesuré en préprod le
 * 07/09/2026 : DEUX réécritures sur trois ne se déclenchaient jamais, en
 * silence. Seule la pastille de date fonctionnait — parce qu'elle est, elle,
 * un nœud unique (« sept. 11 »).
 *
 * D'où le parti pris actuel : ON TRADUIT CHAQUE FRAGMENT POUR CE QU'IL EST.
 * « From » et le prix sont deux traductions indépendantes ; « Up to » et
 * « attendees per timeslot » aussi. Aucun nœud n'est créé, supprimé ni vidé —
 * on ne touche pas à la structure que Preact croit connaître, on ne réécrit
 * que des valeurs de texte.
 *
 * Les motifs de LIGNE ENTIÈRE sont conservés en plus, au cas où un autre
 * chemin de rendu produirait un nœud unique. Ils ne coûtent rien.
 *
 * ── CE QU'IL NE PEUT PAS FAIRE ─────────────────────────────────────────────
 *
 * La page Calendrier est une <iframe> cross-origin vers le domaine de l'éditeur.
 * Ni CSS ni JS ne la traverseront. Ses chaînes anglaises et ses dates au format
 * américain ne se corrigent que chez Servicify (cf. _suivi/signalement-servicify.md).
 *
 * Le libellé « Attendee N » du panier et des e-mails de confirmation reste, lui
 * aussi, hors d'atteinte : l'app nomme ainsi ses propriétés de ligne, et ce nom
 * est STOCKÉ dans la commande. On ne réécrit pas une donnée déjà enregistrée.
 * Seul le titre affiché dans la modale est corrigé ici.
 *
  * ── LES FORMULATIONS, ARBITRÉES PAR LISA LE 09/09/2026 ────────────────────
 *
 *   « 120 minutes »                    → « 2h00 »   (format hh mm imposé : « 0h45 »)
 *   « From €79.00 »                    → « 79,00 € » — SANS « à partir de »,
 *                                        les prix étant uniques
 *   « Up to 6 attendees per timeslot » → « Jusqu’à 6 participants par créneau »
 *                                        conservé tel quel, jugé « plus clair
 *                                        et chaleureux »
 *   « Attendee 1 » (modale)            → « Participant 1 »
 *   « From €0.00 » (prix nul)          → « Gratuit » — Jérémie, 10/09
 *
 * Ces choix sont ceux d'une personne, pas des invariants techniques : les
 * changer se fait ici, en une ligne chacun.
 *
* ── LA GARANTIE, ÉNONCÉE EXACTEMENT ────────────────────────────────────────
 *
 * Chaque fragment est traduit seul et indépendamment. Un fragment non reconnu
 * reste tel quel. Le pire cas est donc un MÉLANGE — un prix resté « 79.00 EUR »
 * si l'éditeur changeait son format — jamais un texte tronqué, vide ou
 * incohérent. C'est délibéré : un correctif cosmétique ne doit pas casser une
 * page de vente.
 *
 * ⚠️ UNE EXCEPTION, DEPUIS LE 09/09 : la durée. Elle se décide au niveau de
 * l'élément et non du fragment, parce que « 120 » et « minutes » vivent dans
 * deux nœuds séparés. La règle y est donc plus stricte — élément feuille, motif
 * ancré sur le contenu entier — mais le principe de repli tient : si le motif
 * ne correspond pas, rien n'est écrit et l'anglais reste.
 *
 * ── LA CONTREPARTIE, MESURÉE EN PRODUCTION LE 07/09/2026 ───────────────────
 *
 * Sur 9 chargements et 8 461 échantillons du texte RÉELLEMENT PEINT (et non de
 * l'écart apparition → écriture, qui ne répond pas à la question), 3 chargements
 * affichent l'anglais pendant EXACTEMENT UNE FRAME — environ 18 ms — avant la
 * réécriture. Jamais deux frames.
 *
 * C'est une course, pas un défaut du code : quand l'app injecte sa grille tard
 * dans la phase de rappels d'animation, après que notre rappel a déjà tourné
 * pour cette frame, le navigateur peint l'anglais et on ne rattrape qu'à la
 * suivante. La préprod ne le montrait JAMAIS (0 sur 1 844 échantillons) : son
 * thread principal plus chargé faisait systématiquement basculer la course du
 * bon côté. Ne pas conclure d'une mesure en préprod que le clignotement
 * n'existe pas.
 *
 * ⚠️ NE PAS chercher à le supprimer en masquant la grille en attendant la
 * traduction. Le mode de panne créé serait bien pire : si ce fichier ne se
 * charge pas, un bloc de vente resterait invisible. Dix-huit millisecondes
 * d'anglais valent mieux qu'une grille vide.
 *
 * ── CORRECTIF TEMPORAIRE ───────────────────────────────────────────────────
 *
 * À RETIRER le jour où Servicify corrige à la source. Retirer alors CE MODULE
 * (l'IIFE qui suit, jusqu'au début du module 2) et rien d'autre : le module 2
 * du même fichier est permanent et protège la vente.
 */

(function () {
  'use strict';

  /* Crochet stable : la valeur du réglage « css_class_names » du bloc, posée
   * par nous dans templates/index.json. Les classes de l'app sont des hachages
   * styled-components régénérés à l'exécution, inutilisables comme sélecteurs.
   * Vérifié : cette classe n'existe que sur ce bloc. La carte de service des
   * pages collection et le calendrier portent des classes distinctes. */
  var RACINE = '.servicify-event-collection-grid';

  /* Mois abrégés tels que moment.js les produit en locale fr. Liste explicite
   * plutôt qu'un motif générique : on ne veut PAS risquer de réécrire un texte
   * qui ressemblerait à une date sans en être une. */
  var MOIS = ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin',
              'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'];

  var ESPACE_FINE = ' ';   // séparateur de milliers français
  var ESPACE_INSEC = ' ';  // avant le symbole monétaire

  /**
   * « €79.00 » → « 79,00 € », « €1234.56 » → « 1 234,56 € ».
   * L'app formate en anglais : symbole devant, point décimal, virgule pour les
   * milliers. Le français fait l'inverse sur les trois points.
   * Renvoie NULL si la chaîne ne correspond pas au motif attendu — l'appelant
   * décide alors de ne rien faire, plutôt que de rendre une valeur douteuse.
   */
  function prixEnFrancais(brut) {
    var m = String(brut).trim().match(/^([€$£])\s*([\d.,]+)$/);
    if (!m) return null;

    var symbole = m[1];
    var nombre = m[2];

    /* Les virgules de l'anglais sont des séparateurs de milliers : on les
     * retire avant de traiter le point décimal, sinon « 1,234.56 » se casse. */
    nombre = nombre.replace(/,/g, '');

    var parts = nombre.split('.');
    if (parts.length > 2) return null;   // « 1.2.3 » : on ne devine pas

    var entiere = parts[0];
    var decimale = parts.length > 1 ? parts[1] : null;
    if (!entiere) return null;

    /* Prix nul : « Gratuit » plutôt que « 0,00 € ».
     * Arbitrage de Jérémie le 10/09 pour la « Démonstration Cristel », une
     * démonstration de marque offerte. Sans « à partir de » — supprimé à la
     * demande de Lisa — « 0,00 € » se lisait comme une erreur de saisie.
     * ⚠️ Ne couvre QUE la grille de l'app. La carte produit des pages
     * collection est rendue par le thème (snippets/price-list.liquid) et
     * affiche toujours « 0,00 € » : notre script ne l'atteint pas. */
    if (parseFloat(entiere + '.' + (decimale || '0')) === 0) return 'Gratuit';

    /* Milliers en espace fine insécable : 1234 → 1 234 */
    entiere = entiere.replace(/\B(?=(\d{3})+(?!\d))/g, ESPACE_FINE);

    return entiere + (decimale !== null ? ',' + decimale : '') + ESPACE_INSEC + symbole;
  }

  /**
   * Traduit le CŒUR d'un nœud de texte, espaces de bord déjà retirés.
   * Renvoie null si rien ne s'applique.
   *
   * L'ordre compte : les motifs de ligne entière passent avant les fragments,
   * sinon « From €79.00 » serait mangé par la règle du fragment « From ».
   */
  function traduireCoeur(t) {
    var m;

    /* ── Lignes entières (chemin de rendu hypothétique, nœud unique) ─────── */

    /* « From €79.00 » — si le prix n'est pas reconnu, on ne traduit RIEN :
     * à ce niveau on dispose de la ligne complète, donc on peut se le permettre. */
    m = t.match(/^From\s+(.+)$/);
    if (m) {
      var prixLigne = prixEnFrancais(m[1]);
      return prixLigne === null ? null : prixLigne;
    }

    /* « Up to 6 attendees per timeslot » */
    m = t.match(/^Up to\s+(\d+)\s+attendees? per timeslot$/);
    if (m) {
      var n = parseInt(m[1], 10);
      return 'Jusqu’à ' + n + (n > 1 ? ' participants' : ' participant') + ' par créneau';
    }

    /* ── Fragments (le chemin réel, mesuré en préprod) ───────────────────── */

    /* « From » DISPARAÎT. Arbitrage de Lisa le 09/09 : « les prix sont uniques,
     * retire à partir de et laisse le prix seul ». On renvoie une chaîne vide et
     * non null — null laisserait « From » à l'écran.
     * ⚠️ Si des prix variables réapparaissaient un jour (plusieurs variantes à
     * des tarifs différents), cette suppression deviendrait un contresens : le
     * prix affiché serait le plus bas sans que rien ne le dise. */
    if (t === 'From') return '';

    if (t === 'Up to') return 'Jusqu’à';

    /* Le prix, seul dans son nœud. */
    var prix = prixEnFrancais(t);
    if (prix !== null) return prix;

    /* « attendees per timeslot » / « attendee per timeslot ».
     * Le nœud porte lui-même le nombre grammatical : pas besoin d'aller lire
     * le nœud voisin qui contient le chiffre. */
    m = t.match(/^(attendees|attendee) per timeslot$/);
    if (m) {
      return (m[1] === 'attendee' ? 'participant' : 'participants') + ' par créneau';
    }

    return null;
  }

  /**
   * Applique traduireCoeur en PRÉSERVANT les espaces de bord, qui portent du
   * sens : « From » et le prix sont deux nœuds, l'espace qui les sépare est
   * l'espace final du premier. Le perdre collerait « À partir de79,00 € ».
   */
  function traduire(brut) {
    var m = String(brut).match(/^(\s*)([\s\S]*?)(\s*)$/);
    var coeur = m[2];
    if (!coeur) return null;
    var nouveau = traduireCoeur(coeur);
    return nouveau === null ? null : m[1] + nouveau + m[3];
  }

  /**
   * Pastilles de dates : « sept. 11 » → « 11 sept. »
   * Traité à part des autres réécritures, et scopé aux seules pastilles, parce
   * qu'un motif « mot + nombre » est trop large pour être lâché sur toute la
   * grille. Le mois doit appartenir à la liste MOIS, sinon on ne touche à rien.
   */
  function dateEnFrancais(texte) {
    var m = texte.match(/^(\s*)(\S+)\s+(\d{1,2})(\s*)$/);
    if (!m) return null;
    if (MOIS.indexOf(m[2].toLowerCase()) === -1) return null;
    return m[1] + m[3] + ' ' + m[2] + m[4];
  }

  /* On ne parcourt jamais le texte d'un <style> ou d'un <script> : l'app
   * injecte une balise <style> À L'INTÉRIEUR de la grille (les règles
   * .eab-grid-view). Aucun de nos motifs ne peut y correspondre aujourd'hui,
   * mais réécrire une feuille de style serait une catastrophe silencieuse, et
   * l'exclure ne coûte rien. */
  var FILTRE = {
    acceptNode: function (noeud) {
      var parent = noeud.parentNode;
      if (parent) {
        var balise = parent.nodeName;
        if (balise === 'STYLE' || balise === 'SCRIPT' || balise === 'TEXTAREA') {
          return NodeFilter.FILTER_REJECT;
        }
      }
      return NodeFilter.FILTER_ACCEPT;
    }
  };

  /* Parcourt les nœuds de texte d'un élément et applique une fonction de
   * réécriture. N'écrit QUE si la valeur change — c'est le garde-fou contre la
   * boucle infinie : notre écriture déclenche une mutation, l'observateur nous
   * rappelle, mais le texte est alors déjà en français et plus aucun motif ne
   * correspond, donc plus aucune écriture. La récursion s'éteint d'elle-même.
   * Vérifié en préprod le 07/09/2026 : 5 cycles adverses, convergence en une
   * seule écriture à chaque fois, puis extinction complète. */
  function parcourir(racine, fn) {
    var marcheur = document.createTreeWalker(racine, NodeFilter.SHOW_TEXT, FILTRE);
    var noeud;
    while ((noeud = marcheur.nextNode())) {
      var remplacement = fn(noeud.nodeValue);
      if (remplacement !== null && remplacement !== noeud.nodeValue) {
        noeud.nodeValue = remplacement;
      }
    }
  }

  /**
   * « 120 minutes » → « 2h00 », « 45 minutes » → « 0h45 ».
   * Format arbitré par Lisa le 09/09 : « garde le format 0h45 ».
   *
   * ⚠️ SEUL CAS OÙ L'ON NE PEUT PAS TRAVAILLER FRAGMENT PAR FRAGMENT.
   * L'app rend ["120", " minutes"] : ni « 120 » seul ni « minutes » seul ne
   * permet de décider. Il faut lire l'ÉLÉMENT entier, écrire le résultat dans
   * son premier nœud de texte et vider les suivants. C'est l'unique entorse au
   * principe du module, et elle est délibérée — voir la leçon en tête de
   * fichier sur le découpage Preact.
   */
  function dureeEnFrancais(minutes) {
    var n = parseInt(minutes, 10);
    if (!isFinite(n) || n < 0) return null;
    var heures = Math.floor(n / 60);
    var reste = n % 60;
    return heures + 'h' + (reste < 10 ? '0' + reste : String(reste));
  }

  function reecrireDurees(racine) {
    var candidats = racine.querySelectorAll('div, span, p');
    for (var i = 0; i < candidats.length; i++) {
      var el = candidats[i];

      /* Feuilles seulement : on ne réécrit jamais un élément qui en contient
       * d'autres, sous peine d'effacer leur contenu en vidant les nœuds. */
      if (el.children.length) continue;

      var m = el.textContent.match(/^\s*(\d+)\s+minutes\s*$/);
      if (!m) continue;

      var duree = dureeEnFrancais(m[1]);
      if (duree === null) continue;

      var premier = true;
      for (var j = 0; j < el.childNodes.length; j++) {
        var noeud = el.childNodes[j];
        if (noeud.nodeType !== 3) continue;
        var cible = premier ? duree : '';
        if (noeud.nodeValue !== cible) noeud.nodeValue = cible;
        premier = false;
      }
    }
  }

  /**
   * Modale de réservation des fiches produit : « Attendee 1 » → « Participant 1 ».
   *
   * Autre surface que la grille, et bien plus simple : l'ancrage
   * [data-servicify="per-attendee-heading"] est posé par l'app elle-même — un
   * attribut de données, pas une classe hachée régénérée à l'exécution. Et le
   * titre est un nœud de texte UNIQUE (`Attendee ${e}` interpolé côté app),
   * donc aucun découpage Preact à gérer ici.
   *
   * Le réglage CAL_ATTENDEE_LABEL de l'app vaut bien « Participant » et
   * fonctionne — mais seulement pour le popover de la jauge. Ce titre-ci ne
   * passe pas par getDisplaySettingValue : il est écrit en dur. Aucune saisie
   * dans l'app ne le corrigera, vérifié dans le bundle le 09/09.
   */
  function participantEnFrancais(texte) {
    var m = texte.match(/^(\s*)Attendee\s+(\d+)(\s*)$/);
    if (!m) return null;
    return m[1] + 'Participant ' + m[2] + m[3];
  }

  function franciserModale() {
    var titres = document.querySelectorAll('[data-servicify="per-attendee-heading"]');
    for (var i = 0; i < titres.length; i++) {
      parcourir(titres[i], participantEnFrancais);
    }
  }

  function franciserGrille() {
    var grilles = document.querySelectorAll(RACINE);
    if (!grilles.length) return;

    for (var i = 0; i < grilles.length; i++) {
      /* Les fragments des lignes anglaises. */
      parcourir(grilles[i], traduire);

      /* Les durées, qui exigent une lecture au niveau de l'élément. */
      reecrireDurees(grilles[i]);

      /* Les pastilles de dates. Sélecteur repris de custom.css : le bouton de
       * réservation est le seul <a href="#"> de la carte, ses <div> frères sont
       * les pastilles. :has() est supporté par tous les navigateurs visés
       * (vérifié en préprod) ; on l'enveloppe tout de même, un sélecteur
       * invalide ne doit pas emporter le reste. */
      var pastilles;
      try {
        pastilles = grilles[i].querySelectorAll('div:has(> a[href="#"]) > div');
      } catch (e) {
        pastilles = [];
      }
      for (var j = 0; j < pastilles.length; j++) {
        parcourir(pastilles[j], dateEnFrancais);
      }
    }
  }

  /* Les deux surfaces sont traitées à chaque passe. Chacune sort en une ligne
   * si elle n'est pas présente : la grille n'existe que sur l'accueil, la
   * modale que sur une fiche produit, jamais les deux à la fois. */
  function franciser() {
    franciserGrille();
    franciserModale();
  }

  /* Coalescence par frame : l'app rend en Preact et produit des rafales de
   * mutations. Sans cela on rejouerait la traversée des dizaines de fois pour
   * un seul rendu. Coût mesuré en préprod : médiane 0,1 ms par passe, 27 ms
   * cumulés sur tout le chargement, 0 ms après stabilisation. */
  var planifie = false;
  function planifier() {
    if (planifie) return;
    planifie = true;
    requestAnimationFrame(function () {
      planifie = false;
      try {
        franciser();
      } catch (e) {
        /* Échec silencieux, volontairement : l'anglais d'origine reste affiché.
         * Un correctif cosmétique ne doit jamais casser une page de vente. */
      }
    });
  }

  /* On observe tout le document, pas seulement la grille : celle-ci est injectée
   * par l'app APRÈS le chargement, elle n'existe pas encore au moment où ce
   * script s'exécute. Le filtrage se fait dans franciser(), qui sort en une
   * ligne si aucune grille n'est présente — mesuré sans effet sur les pages qui
   * n'en portent pas (collection, fiche produit, calendrier : 0 écriture). */
  function demarrer() {
    planifier();
    new MutationObserver(planifier).observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();

/* ===========================================================================
 * MODULE 2 — Option « Offrir » : transmettre le message cadeau, et rien de
 *            plus que ce que le client a choisi d'envoyer
 * ===========================================================================
 *
 * Tâche Asana « Le message personnalisé de "Offrir un cours" part dans les
 * limbes » (1218187705699078), section Dev — 09/09/2026.
 *
 * Remplace les blocs `liquid` inline de templates/product.cours-de-cuisine.json
 * (liquid_KUEEJL) et templates/product.ateliers-techniques.json (liquid_N7KTWX),
 * qui portaient DEUX implémentations divergentes de la même fonction — et la
 * même faille.
 *
 * ── CE QUE CE MODULE CORRIGE — mesuré en production le 10/09/2026 ─────────
 *
 * Sur les fiches cours et ateliers, l'achat NE PASSE PAS par le formulaire du
 * thème. L'app de réservation Easy Appointment Booking masque le bouton
 * « Ajouter au panier » (display:none) et le remplace par le sien, un
 * <button type="button"> qui ne soumet rien. C'est l'app qui compose la ligne
 * de panier, en moissonnant elle-même les propriétés. Son sélecteur, lu dans
 * son bundle embedInit.js :
 *
 *   document.querySelectorAll(
 *     "input[name^='properties'], option[name^='properties'], option[data-value-handle]")
 *
 * D'où deux défauts, tous deux vécus par des clients :
 *
 * 1. LE MESSAGE CADEAU ÉTAIT PERDU. Le sélecteur ne retient jamais un
 *    <textarea>. Le petit mot du client n'arrivait ni au panier ni à la
 *    commande, sans la moindre erreur. → relais <input type="hidden">,
 *    voir synchroniserZonesDeTexte().
 *
 * 2. LES COORDONNÉES D'UN DESTINATAIRE ABANDONNÉ PARTAIENT QUAND MÊME. Le
 *    sélecteur ne consulte pas `disabled`. Un client qui cochait « Offrir »,
 *    saisissait un destinataire puis décochait envoyait ces coordonnées dans
 *    la commande. → les valeurs sont vidées au décochage, voir basculer().
 *
 * ── UN RISQUE LATENT — PAS UN BUG VÉCU ────────────────────────────────────
 *
 * ⚠️ La première version de ce commentaire affirmait que les anciens scripts
 * « bloquaient l'ajout au panier en silence » dans le parcours normal. C'était
 * un diagnostic tiré de la seule lecture du code, et le test réel l'a
 * INFIRMÉ : le bouton natif étant masqué par l'app, aucun client n'atteint la
 * validation HTML. Cette affirmation a été relayée à tort par une autre
 * session avant d'être corrigée. Ne pas la rejouer.
 *
 * Le risque existe pourtant, en réserve. « Nom » et « Email du destinataire »
 * portent l'attribut `required` (snippets/input.liquid:40), et `display:none`
 * ne les exempte PAS de la validation de contrainte — seuls `disabled`,
 * `readonly` et `type="hidden"` le font. Si l'app embed était un jour
 * désactivée, le bouton natif reviendrait ; avec des champs masqués mais
 * actifs, il ne ferait RIEN (« An invalid form control … is not focusable »).
 * C'est le rôle du premier volet ci-dessous.
 *
 * ── DEUX PROTECTIONS, AUCUNE REDONDANTE ───────────────────────────────────
 *
 * 1. `disabled` — le filet du risque latent. Il retire le champ de la
 *    validation de contrainte ET de FormData, donc couvre le chemin natif du
 *    thème le jour où il redeviendrait actif.
 *    C'est ce que fait déjà le thème pour son destinataire de carte-cadeau
 *    natif, dont le champ e-mail est lui aussi `required: true` dans un
 *    conteneur masqué (snippets/buy-buttons.liquid:69). Voir theme.js:2816-2819 :
 *
 *        properties.forEach((p) => p.disabled = !checkbox.checked);
 *        fieldsContainer.toggleAttribute("hidden", !checkbox.checked);
 *
 *    `disabled` d'abord, masquage ensuite. Maestrooo avait raison ; on l'imite.
 *
 * 2. ⚠️ MAIS `disabled` NE SUFFIT PAS ICI, et c'est contre-intuitif. L'app de
 *    réservation Easy Appointment Booking n'utilise PAS FormData : elle
 *    moissonne elle-même les [name^="properties["] et lit `.value` sans
 *    regarder `disabled`. Vérifié en préprod le 09/09/2026 par une réservation
 *    réelle (voir le détail dans basculer()). Il faut donc AUSSI vider les
 *    valeurs — sans quoi un client qui coche, saisit, puis décoche envoie
 *    quand même les coordonnées d'un destinataire au panier et à la commande.
 *
 * Le raisonnement statique seul menait à la mauvaise conclusion : c'est le test
 * sur le trafic réel qui a tranché. Ne pas « simplifier » en retirant l'un des
 * deux volets sans refaire une réservation de bout en bout.
 *
 * ── POURQUOI ON NE TOUCHE PAS À `required` ────────────────────────────────
 *
 * C'est redondant (`disabled` prime), cela retirerait le réglage des mains du
 * Customizer, et cela obligerait à coder en dur quels champs sont obligatoires.
 * Surtout : le mode dégradé « ce fichier ne se charge pas » devient alors trois
 * champs visibles et obligatoires — laid, mais la boutique VEND. Le danger n'a
 * jamais été `required`, c'était de masquer sans désactiver.
 *
 * ── POURQUOI ICI ET PAS DANS UN BLOC `liquid` ─────────────────────────────
 *
 * 1. Un bloc `liquid` est un RÉGLAGE de templates/*.json : le Customizer le
 *    supprime d'un clic, et un `theme pull` rapatrierait la suppression. Une
 *    protection contre un blocage de vente ne doit pas tenir à ça.
 * 2. snippets/product-quick-buy.liquid n'a PAS de branche `when 'liquid'` : un
 *    bloc liquid ne peut STRUCTURELLEMENT pas protéger le tiroir d'achat rapide,
 *    où les mêmes champs sont rendus avec le même `required`.
 * 3. assets/theme.js remplace les blocs de type `liquid` à chaque changement de
 *    variante en ré-exécutant leur <script> : l'ancienne version empilait un
 *    écouteur de plus à chaque clic sur une date.
 * 4. Un seul code pour les deux templates — et pour tout template futur.
 *
 * ── CE QU'IL NE FAIT PAS ──────────────────────────────────────────────────
 *
 * Il ne valide pas le format de l'e-mail : le bloc est réglé sur `type: "text"`,
 * donc input type="text". Passer le champ en type="email" serait une
 * amélioration réelle, à traiter séparément.
 */

(function () {
  'use strict';

  /* Le seul crochet stable, et il est présent dans les DEUX rendus du thème :
   *   snippets/product-info.liquid:297      — fiche produit
   *   snippets/product-quick-buy.liquid:62  — tiroir d'achat rapide
   * AUCUN identifiant de bloc en dur — c'était le défaut de liquid_KUEEJL, qui
   * cassait au moindre bloc réordonné ou dupliqué dans le Customizer. Et aucun
   * test sur le libellé : « Offrir le cours 🎁 » et « Offrir l'atelier 🎁 » sont
   * deux textes différents pour la même fonction. */
  var SEL_PROPRIETE = '.product-info__property';

  function premierControle(propriete) {
    return propriete.querySelector('input, textarea, select');
  }

  function estCase(ctrl) {
    return !!ctrl && ctrl.type === 'checkbox';
  }

  /* Le conteneur à masquer n'est pas le même dans les deux rendus :
   *
   * - Fiche produit : le parent .product-info__block-item[data-block-id]
   *   (snippets/product-info.liquid:498-507) porte la marge inter-blocs. Ne
   *   masquer que l'intérieur laisserait TROIS trous verticaux.
   * - Achat rapide : ce parent n'existe pas, on masque la propriété elle-même.
   *
   * `closest` règle les deux cas sans branche conditionnelle. */
  function conteneur(propriete) {
    return propriete.closest('[data-block-id]') || propriete;
  }

  /**
   * Regroupe les propriétés par FORMULAIRE PROPRIÉTAIRE, en ordre du document.
   *
   * Indispensable : une page peut porter plusieurs formulaires produit (tiroir
   * d'achat rapide par-dessus une collection, produits complémentaires…). On lit
   * l'ATTRIBUT `form` et non la propriété `.form`, pour ne pas dépendre du fait
   * que le <form> soit déjà dans le DOM.
   *
   * document.querySelectorAll ne traverse PAS le contenu d'un <template> : la
   * copie d'achat rapide, rendue inconditionnellement en bas de
   * sections/main-product.liquid, est donc invisible ici tant que le tiroir
   * n'est pas ouvert. Vérifié sur le HTML servi le 09/09/2026 : 8 champs
   * `properties[…]` dans la page, dont 4 à l'intérieur du <template>. C'est voulu.
   */
  function groupes() {
    var proprietes = document.querySelectorAll(SEL_PROPRIETE);
    var cles = [];
    var listes = [];

    for (var i = 0; i < proprietes.length; i++) {
      var ctrl = premierControle(proprietes[i]);
      if (!ctrl) continue;

      var cle = ctrl.getAttribute('form') || '(sans-formulaire)';
      var rang = cles.indexOf(cle);
      if (rang === -1) {
        rang = cles.length;
        cles.push(cle);
        listes.push([]);
      }
      listes[rang].push(proprietes[i]);
    }

    return listes;
  }

  /**
   * Affiche ou masque UNE propriété dépendante.
   *
   * ⚠️ L'ORDRE DES DEUX OPÉRATIONS EST DÉLIBÉRÉ. On désactive avant de masquer,
   * et on réaffiche avant de réactiver. Si une exception tombait entre les deux,
   * l'état atteint serait « désactivé mais visible » ou « visible mais
   * désactivé » : moches, jamais bloquants. L'état bloquant — « masqué ET actif »,
   * exactement le bug qu'on corrige — n'est atteignable dans aucun ordre
   * d'interruption.
   *
   * ⚠️ ON VIDE AUSSI LES VALEURS, et c'est INDISPENSABLE — mesuré en préprod le
   * 09/09/2026. `disabled` ne suffit PAS : l'app Easy Appointment Booking
   * n'utilise pas FormData. Elle moissonne elle-même les [name^="properties["]
   * et lit `.value` SANS vérifier `disabled`. Test réel, case décochée, champs
   * pré-remplis puis désactivés — le panier a quand même reçu :
   *
   *   "Nom du destinataire": "NE-DOIT-PAS-PARTIR"
   *   "Email du destinataire": "NE-DOIT-PAS-PARTIR"
   *
   * Les deux protections sont donc complémentaires et aucune n'est redondante :
   *   - `disabled` couvre la validation de contrainte et FormData (le bouton
   *     natif du thème, aujourd'hui masqué par l'app mais qui réapparaîtrait
   *     si l'app embed était désactivée) ;
   *   - vider la valeur couvre le moissonnage de l'app, seul chemin réellement
   *     emprunté par les clients aujourd'hui.
   *
   * Pour ne rien faire perdre au client, les valeurs sont mémorisées sur
   * l'élément avant d'être effacées, et restituées au recochage. Décocher puis
   * recocher rend donc bien ce qui avait été écrit.
   */
  function basculer(propriete, visible) {
    /* Les relais (voir synchroniserZonesDeTexte) sont exclus : ils ne sont pas
     * saisis par le client et sont recalculés depuis leur zone de texte. Les
     * inclure ici ferait deux mécanismes concurrents sur la même valeur. */
    var champs = propriete.querySelectorAll('input:not([data-relais-textarea]), textarea, select');
    var k, c;

    if (visible) {
      conteneur(propriete).style.display = '';
      for (k = 0; k < champs.length; k++) {
        c = champs[k];
        c.disabled = false;
        if (c.type !== 'checkbox' && c.type !== 'radio' && c._valeurMemorisee) {
          c.value = c._valeurMemorisee;
          c._valeurMemorisee = null;
        }
      }
    } else {
      for (k = 0; k < champs.length; k++) {
        c = champs[k];
        if (c.type !== 'checkbox' && c.type !== 'radio' && c.value) {
          c._valeurMemorisee = c.value;
          c.value = '';
        }
        c.disabled = true;
      }
      conteneur(propriete).style.display = 'none';
    }
  }

  /**
   * RELAIS DES ZONES DE TEXTE MULTILIGNE
   *
   * Problème : l'app de réservation ne transmet JAMAIS le contenu d'un
   * <textarea>. Ce n'est pas une hypothèse — c'est son propre sélecteur, lu
   * dans son bundle (embedInit.js, 09/09/2026) :
   *
   *   document.querySelectorAll(
   *     "input[name^='properties'], option[name^='properties'], option[data-value-handle]"
   *   ).filter(e => !e.dataset.servicifyLabel && !e.dataset.servicifyInput)
   *
   * `input` et `option` seulement. Le même sélecteur explique aussi pourquoi
   * `disabled` ne protège de rien : il n'est jamais consulté.
   *
   * Conséquence vécue : le « petit mot » que le client écrit en offrant un cours
   * n'arrivait ni au panier, ni à la commande, ni nulle part. Sans erreur.
   *
   * Solution : laisser au client sa zone de texte — un mot d'amour tient
   * rarement sur une ligne — et lui adosser un <input type="hidden"> portant le
   * MÊME `name`, que l'app, elle, sait lire. On ne touche pas au <textarea> :
   * il garde son nom et continue d'alimenter le chemin natif du thème.
   *
   * Le doublon de `name` est sans conséquence : sur le chemin de l'app seul le
   * relais est vu ; sur le chemin natif les deux valeurs sont identiques.
   *
   * Mode dégradé : si ce fichier ne se charge pas, le relais n'existe pas et on
   * retombe exactement sur le comportement d'avant — message perdu, rien de
   * cassé. C'est le pire cas, et il est acceptable.
   *
   * ⚠️ À RETIRER si Servicify corrige (points 6 et 7 du signalement) : le
   * <textarea> serait alors transmis seul, et le relais ferait doublon.
   */
  function synchroniserZonesDeTexte() {
    var zones = document.querySelectorAll('.product-info__property textarea[name]');
    var i, z, relais, cible;

    for (i = 0; i < zones.length; i++) {
      z = zones[i];
      if (z.closest('template')) continue;          /* copie d'achat rapide inerte */
      if (z.name.indexOf('properties[') !== 0) continue;

      relais = z._relais;
      if (!relais || !relais.isConnected) {
        relais = document.createElement('input');
        relais.type = 'hidden';
        relais.name = z.name;
        relais.setAttribute('data-relais-textarea', '');
        cible = z.getAttribute('form');
        if (cible) relais.setAttribute('form', cible);
        z.parentNode.insertBefore(relais, z.nextSibling);
        z._relais = relais;
      }

      /* Le relais suit sa zone en tout : valeur ET état. Quand la case « Offrir »
       * est décochée, basculer() a désactivé et vidé la zone — le relais devient
       * vide à son tour, donc rien ne part au panier. */
      relais.disabled = z.disabled;
      relais.value = z.disabled ? '' : z.value;
    }
  }

  /**
   * Règle de rattachement, unique et explicite :
   *
   *   UNE PROPRIÉTÉ DE TYPE CASE À COCHER GOUVERNE TOUTES LES PROPRIÉTÉS QUI LA
   *   SUIVENT DANS LE MÊME FORMULAIRE, JUSQU'À LA CASE SUIVANTE OU LA FIN.
   *
   * C'est la règle qu'appliquait déjà le bloc des ateliers techniques ; on la
   * garde parce qu'elle survit à un réordonnancement ou un renommage dans le
   * Customizer, contrairement à une liste d'identifiants.
   *
   * ⚠️ Corollaire à connaître avant d'ajouter une propriété : une case à cocher
   * ajoutée AVANT d'autres champs les rendra conditionnels. Si ce n'est pas
   * l'intention, placer la case en DERNIER.
   */
  function appliquerAuGroupe(liste) {
    for (var i = 0; i < liste.length; i++) {
      var declencheur = premierControle(liste[i]);
      if (!estCase(declencheur)) continue;

      /* Firefox restitue l'état des formulaires au rechargement et au retour
       * arrière. Sans autocomplete="off", la case pourrait revenir cochée sans
       * que nos écouteurs aient rejoué. Repris de l'ancien script. */
      declencheur.setAttribute('autocomplete', 'off');

      /* Repris tel quel de liquid_KUEEJL, avec son intention d'origine : forcer
       * la VALEUR à refléter l'état, pour les scripts tiers (app de réservation)
       * qui liraient .value sans vérifier .checked. Une case décochée n'est de
       * toute façon jamais soumise nativement — ceci ne protège que du
       * moissonnage tiers.
       * ⚠️ NON VÉRIFIÉ : on ignore quel tiers l'a rendu nécessaire. Conservé par
       * prudence, à retester avant de le retirer un jour. */
      declencheur.value = declencheur.checked ? '1' : '';

      var j;
      for (j = i + 1; j < liste.length; j++) {
        if (estCase(premierControle(liste[j]))) break;  /* propriété d'une autre case */
        basculer(liste[j], declencheur.checked);
      }
      i = j - 1;  /* on reprend l'itération sur la case suivante */
    }
  }

  function appliquer() {
    var g = groupes();
    for (var i = 0; i < g.length; i++) appliquerAuGroupe(g[i]);
    synchroniserZonesDeTexte();   /* toujours APRÈS la bascule : le relais copie l'état final */
  }

  /* Échec silencieux — cohérent avec le module 1, et sans danger ici grâce à
   * l'ordre des opérations de basculer(). Le pire cas est un champ visible qu'on
   * aurait voulu masquer, jamais un formulaire bloqué. */
  function appliquerSansCasser() {
    try {
      appliquer();
    } catch (e) {
      /* volontairement muet */
    }
  }

  /* Coalescence par frame, pour les rappels de re-rendu qui peuvent tomber en
   * rafale. Le chemin d'interaction, lui, reste synchrone : le client doit voir
   * les champs apparaître au moment où il coche. */
  var planifie = false;
  function planifier() {
    if (planifie) return;
    planifie = true;
    requestAnimationFrame(function () {
      planifie = false;
      appliquerSansCasser();
    });
  }

  /* ── 1. L'interaction ──────────────────────────────────────────────────
   * Écouteur DÉLÉGUÉ sur `document`, jamais posé sur la case elle-même : le
   * thème remplace le DOM de la fiche produit (assets/theme.js:3334,
   * `this.replaceWith(matchingElement)`) lors d'un changement de produit. Un
   * écouteur posé sur l'élément mourrait avec lui et ne serait jamais reposé —
   * c'est précisément le défaut du bloc liquid_N7KTWX des ateliers techniques. */
  document.addEventListener('change', function (event) {
    var cible = event.target;
    if (cible && cible.closest && cible.closest(SEL_PROPRIETE)) {
      appliquerSansCasser();
    }
  });

  /* Saisie au fil de l'eau dans une zone de texte. `change` ne suffirait pas :
   * il n'arrive qu'à la perte du focus, et le bouton de réservation de l'app
   * peut être atteint au clavier sans que la zone ait rendu le focus. On
   * resynchronise donc à chaque frappe — l'opération est une simple copie de
   * chaîne, sans coût mesurable. */
  document.addEventListener('input', function (event) {
    var cible = event.target;
    if (cible && cible.tagName === 'TEXTAREA' && cible.closest && cible.closest(SEL_PROPRIETE)) {
      try { synchroniserZonesDeTexte(); } catch (e) { /* muet, comme le reste */ }
    }
  });

  /* ── 2. Après un re-rendu du thème ─────────────────────────────────────
   * `product:rerender` est émis SANS `bubbles` sur le formulaire : il ne remonte
   * donc pas jusqu'à `document` en phase de bouillonnement. Mais la phase de
   * CAPTURE a lieu quoi qu'il arrive — d'où le `true` final. Comme la capture
   * précède la cible, l'échange du DOM n'a pas encore eu lieu : on reporte à la
   * frame suivante via planifier(). */
  document.addEventListener('product:rerender', planifier, true);

  /* ── 3. Filet ──────────────────────────────────────────────────────────
   * `variant:change` bouillonne et arrive APRÈS l'échange du DOM, mais n'est pas
   * émis lors d'un changement de PRODUIT : les deux rappels sont complémentaires,
   * pas redondants. */
  document.addEventListener('variant:change', planifier);

  /* ── 4. Tiroir d'achat rapide ──────────────────────────────────────────
   * QuickBuyDrawer.show() injecte son contenu juste avant `dialog:after-show`,
   * qui bouillonne. Inactif aujourd'hui (show_quick_buy: false), mais c'est LA
   * raison pour laquelle ce code ne peut pas vivre dans un bloc `liquid`. */
  document.addEventListener('dialog:after-show', planifier);

  /* ── 5. Retour arrière navigateur (bfcache) ────────────────────────────*/
  window.addEventListener('pageshow', planifier);

  /* ── 6. Personnalisateur Shopify ───────────────────────────────────────*/
  document.addEventListener('shopify:section:load', planifier);

  /* custom.js est chargé en `defer` (layout/theme.liquid:89) : à l'exécution le
   * document est déjà analysé, donc la branche immédiate suffit. La branche
   * DOMContentLoaded n'est qu'un filet. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', appliquerSansCasser);
  } else {
    appliquerSansCasser();
  }
})();

/* ===========================================================================
 * MODULE 3 — Cartes produit : prochaines dates du cours et places restantes
 * ===========================================================================
 *
 * Tâche Asana « Refonte des cartes produit » (1218728533051634), maquette v4
 * de Lisa — 23/09/2026. Passage à la liste des prochaines dates : tâche
 * « Mettre à jour l'apparence des cartes produit » (1219433644647832) —
 * 13/10/2026. PERMANENT.
 *
 * snippets/labo-card-booking.liquid rend, dans chaque carte produit, un
 * emplacement vide et masqué (.labo-card__dates). Ce module y construit la
 * liste des prochaines séances depuis l'app Easy Appointment Booking, seule
 * source de ces données — aucune saisie à doubler dans Shopify : une date
 * ajoutée, déplacée ou réservée dans l'app se voit au chargement suivant.
 *
 * ── D'OÙ VIENNENT LES DONNÉES — routes publiques de l'app ────────────────
 *
 * Un produit = un événement ; une séance = un créneau de `specialHours`.
 * Deux appels par carte, sans authentification — ce sont ceux que l'app émet
 * elle-même sur les fiches produit (bundle embedInit.js), donc ouverts en
 * CORS depuis la vitrine :
 *
 *   GET  /api/products/<productId>/events?variantId=<variantId>
 *        → l'événement : id, numAttendees (la jauge), capacityRules, et ses
 *          employés avec leurs specialHours :
 *          {"2026-10-21": ["17:00-18:30"], "2026-10-24": ["10:00-11:30"]}.
 *          ⚠️ Sans `variantId`, la route répond « there is no event for this
 *          product » alors que l'événement existe. 204 = pas d'événement.
 *   POST /api/events/<eventId>/employees/busy-slots
 *        → toutes les réservations de la plage première → dernière séance,
 *          chacune avec sa date (`startDateString`) et son heure (`startTime`,
 *          « 5:00 pm »). Un seul appel quelle que soit la longueur de la liste.
 *
 * ⚠️ La jauge est `numAttendees` (« Max attendees per slot » dans l'app), PAS
 * `maximumAttendeesPerTimeslot`, qui n'est que le plafond d'UNE réservation.
 * Lu dans le bundle (getEffectiveEventCapacity). Si l'événement porte des
 * capacityRules (jauge qui varie selon la date), on n'affiche PAS de pastille :
 * un nombre faux serait pire qu'aucun.
 *
 * ── RÈGLES D'AFFICHAGE (spec de Lisa, arbitrages de Jérémie du 13/10) ─────
 *
 *   une ligne par séance future, de la plus proche à la plus lointaine
 *   « Mer. 21 oct. · 17h » (« 10h30 » si les minutes ne sont pas nulles)
 *   restantes ≥ 5   « N places »         vert
 *   2 à 4           « Reste N places »   orange
 *   1               « Dernière place »   rose
 *   0               « Complet »          gris, ligne grisée et non cliquable
 *   démonstration   jamais de pastille (data-demo, posé en Liquid pour le
 *                   template product.demonstrations) ; une séance pleine y est
 *                   quand même grisée.
 *   3 lignes au plus, les suivantes dans un tiroir : « + N autres dates » /
 *   « Masquer les dates ».
 *   toutes les séances pleines → CTA gris « Complet », non cliquable.
 *
 * ── OUVRIR LA RÉSERVATION SUR UNE DATE ────────────────────────────────────
 *
 * Un clic sur une ligne — ou sur « Réserver », qui vise la première séance
 * disponible — mène à la fiche produit en ayant posé la clé localStorage
 * SERVICIFY_OPEN_CALENDAR. C'est le mécanisme INTERNE de l'app, celui de sa
 * page Calendrier, lu dans le bundle digital-appointments-572 (13/10/2026) :
 *
 *   localStorage["SERVICIFY_OPEN_CALENDAR"] =
 *     JSON.stringify({ value: JSON.stringify({ eventId, start }), expiry })
 *
 * Au chargement de la fiche, l'app ouvre son calendrier, présélectionné sur
 * `start`, si `eventId` est le sien et que la clé n'a pas expiré (60 s).
 * ⚠️ Non documenté par l'éditeur : une mise à jour de l'app peut l'ignorer.
 * Le clic retombe alors sur la fiche simple, sans erreur — c'est le repli voulu.
 *
 * ── MODE DE PANNE ─────────────────────────────────────────────────────────
 *
 * Tout échec (réseau, réponse inattendue, pas d'événement, aucune séance
 * future) laisse la carte telle que le Liquid l'a rendue : prix et
 * « Réserver », sans liste. Jamais de carte cassée, jamais de « Complet » par
 * erreur : un échec du comptage des places donne une liste sans pastille.
 */
(function () {
  'use strict';

  var API = 'https://servicify-appointments.herokuapp.com';
  var FUSEAU = 'Europe/Paris';
  var MAX_EN_VOL = 4;
  var LIGNES_VISIBLES = 3;
  var CLE_OUVERTURE = 'SERVICIFY_OPEN_CALENDAR';
  var OUVERTURE_MS = 60000;

  var memo = {};        // productId → Promise<données|null>, pour la page

  /* Cache par visiteur, 120 s — décision de Jérémie du 23/09/2026.
   * Chaque carte coûte 2 appels à l'app, l'un après l'autre (~0,9 s mesurés) :
   * sans cache, chaque retour sur le catalogue les refait tous. Contrepartie
   * acceptée : une place prise par un autre client peut mettre jusqu'à 2 min
   * à se voir. Sans risque de survente : c'est l'app qui refuse une
   * réservation au-delà de la jauge, pas la pastille.
   * sessionStorage : propre à l'onglet, vidé à sa fermeture. Seules les
   * réponses complètes sont gardées — jamais un échec réseau, pour qu'une
   * panne passagère de l'app ne se prolonge pas deux minutes. Tout accès est
   * sous try : navigation privée ou stockage bloqué = pas de cache, rien de plus.
   * Préfixe « labo-card2: » depuis la liste de dates (13/10) : les entrées de
   * l'ancien format, à séance unique, ne sont jamais relues. */
  var CACHE_MS = 120000;
  var CACHE_PREFIXE = 'labo-card2:';

  function lireCache(productId) {
    try {
      var brut = sessionStorage.getItem(CACHE_PREFIXE + productId);
      if (!brut) return undefined;
      var entree = JSON.parse(brut);
      if (Date.now() - entree.t > CACHE_MS) return undefined;
      return entree.d;
    } catch (e) { return undefined; }
  }

  function ecrireCache(productId, donnees) {
    try {
      sessionStorage.setItem(CACHE_PREFIXE + productId, JSON.stringify({ t: Date.now(), d: donnees }));
    } catch (e) { /* quota, stockage bloqué : sans cache */ }
  }

  var file = [];
  var enVol = 0;

  function limiter(tache) {
    return new Promise(function (resoudre, rejeter) {
      file.push(function () {
        enVol++;
        tache().then(resoudre, rejeter).then(function () {
          enVol--;
          if (file.length) file.shift()();
        });
      });
      if (enVol < MAX_EN_VOL) file.shift()();
    });
  }

  function json(reponse) {
    if (!reponse.ok) throw new Error('HTTP ' + reponse.status);
    // 204 = produit sans événement (la carte cadeau) : une vraie réponse, à
    // mettre en cache comme les autres — pas un échec.
    if (reponse.status === 204) return null;
    return reponse.json();
  }

  /* ── Dates et heures, toujours à Paris ──────────────────────────────── */

  /* Maintenant à Paris : { jour: 'AAAA-MM-JJ', heure: 'HH:MM' }. */
  function maintenant() {
    var morceaux = {};
    new Intl.DateTimeFormat('en-CA', {
      timeZone: FUSEAU, year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
    }).formatToParts(new Date()).forEach(function (p) { morceaux[p.type] = p.value; });
    return {
      jour: morceaux.year + '-' + morceaux.month + '-' + morceaux.day,
      heure: morceaux.hour + ':' + morceaux.minute
    };
  }

  /* « 9:30 » → « 09:30 » ; « 5:00 pm » → « 17:00 ». */
  function heure24(texte) {
    var m = /^\s*(\d{1,2}):(\d{2})\s*(am|pm)?\s*$/i.exec(texte || '');
    if (!m) return null;
    var h = parseInt(m[1], 10);
    if (m[3]) {
      var pm = m[3].toLowerCase() === 'pm';
      if (h === 12) h = pm ? 12 : 0; else if (pm) h += 12;
    }
    return (h < 10 ? '0' : '') + h + ':' + m[2];
  }

  /* Instant UTC (ISO) d'une heure de Paris : le décalage du jour est lu par
   * Intl (« GMT+02:00 » l'été, « GMT+01:00 » l'hiver). */
  function debutISO(jour, heure) {
    try {
      var p = jour.split('-');
      var midi = new Date(Date.UTC(+p[0], +p[1] - 1, +p[2], 12));
      var nom = new Intl.DateTimeFormat('en-US', { timeZone: FUSEAU, timeZoneName: 'longOffset' })
        .formatToParts(midi).filter(function (x) { return x.type === 'timeZoneName'; })[0].value;
      var decalage = (nom.replace('GMT', '') || '+00:00');
      return new Date(jour + 'T' + heure + ':00' + decalage).toISOString();
    } catch (e) { return null; }
  }

  /* Toutes les séances futures de l'événement, triées, sans doublon. Un jour
   * peut porter plusieurs créneaux : une ligne chacun. Les créneaux du jour
   * déjà commencés sont exclus. */
  function seancesFutures(evenement) {
    var ici = maintenant();
    var vues = {};
    var seances = [];
    (evenement.employees || []).forEach(function (employe) {
      var horaires = (employe && employe.specialHours) || {};
      Object.keys(horaires).forEach(function (jour) {
        if (jour < ici.jour) return;
        (horaires[jour] || []).forEach(function (creneau) {
          var heure = heure24(String(creneau || '').split('-')[0]);
          if (!heure) return;
          if (jour === ici.jour && heure <= ici.heure) return;
          var cle = jour + '|' + heure;
          if (vues[cle]) return;
          vues[cle] = true;
          seances.push({ jour: jour, heure: heure, debut: debutISO(jour, heure), restantes: null });
        });
      });
    });
    seances.sort(function (a, b) {
      return (a.jour + a.heure) < (b.jour + b.heure) ? -1 : 1;
    });
    return seances;
  }

  function charger(productId, variantId) {
    if (memo[productId]) return memo[productId];

    var enCache = lireCache(productId);
    if (enCache !== undefined) {
      memo[productId] = Promise.resolve(enCache);
      return memo[productId];
    }

    memo[productId] = limiter(function () {
      return fetch(API + '/api/products/' + productId + '/events?variantId=' + variantId)
        .then(json)
        .then(function (reponse) {
          var evenement = Array.isArray(reponse) ? reponse[0] : reponse;
          if (!evenement || !evenement.id || evenement.isActive === false) return null;

          var seances = seancesFutures(evenement);
          if (!seances.length) return null;
          var donnees = { eventId: evenement.id, seances: seances };

          var jauge = parseInt(evenement.numAttendees, 10);
          var jaugeFiable = Number.isFinite(jauge) && jauge > 0 &&
            !(evenement.capacityRules && evenement.capacityRules.length);
          if (!jaugeFiable) return donnees;

          var employes = (evenement.employees || []).map(function (e) { return e.id; });
          return fetch(API + '/api/events/' + evenement.id + '/employees/busy-slots', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              employeeIds: employes,
              dateFrom: seances[0].jour,
              dateTo: seances[seances.length - 1].jour,
              inputTimezone: FUSEAU
            })
          })
            .then(json)
            .then(function (occupation) {
              var prises = {};
              var parEmploye = (occupation && occupation.bookings) || {};
              Object.keys(parEmploye).forEach(function (id) {
                (parEmploye[id] || []).forEach(function (resa) {
                  if (!resa || resa.eventId !== evenement.id || !resa.date) return;
                  var cle = resa.date.startDateString + '|' + heure24(resa.date.startTime);
                  prises[cle] = (prises[cle] || 0) + (parseInt(resa.quantity, 10) || 0);
                });
              });
              seances.forEach(function (s) {
                s.restantes = Math.max(0, jauge - (prises[s.jour + '|' + s.heure] || 0));
              });
              return donnees;
            })
            .catch(function () { return { echec: true, valeur: donnees }; });
        })
        .catch(function () { return { echec: true, valeur: null }; });
    }).then(function (resultat) {
      if (resultat && resultat.echec) return resultat.valeur;   // affiché, jamais gardé
      ecrireCache(productId, resultat);
      return resultat;
    });
    return memo[productId];
  }

  /* ── Rendu ──────────────────────────────────────────────────────────── */

  var SVG = 'http://www.w3.org/2000/svg';
  var ICONES = {
    calendrier: '<rect x="3" y="4.5" width="18" height="16.5" rx="2"/><path d="M3 9.5h18M8 2.5v4M16 2.5v4"/>',
    personnes: '<circle cx="9" cy="8" r="3.5"/><path d="M2.5 20c0-3.6 2.9-6 6.5-6s6.5 2.4 6.5 6"/><path d="M16 4.7a3.5 3.5 0 0 1 0 6.6M18 14.3c2.2.7 3.5 2.8 3.5 5.7"/>',
    interdit: '<circle cx="12" cy="12" r="9"/><path d="M5.6 5.6l12.8 12.8"/>',
    chevron: '<path d="M6 9l6 6 6-6"/>'
  };

  function icone(nom, classe) {
    var svg = document.createElementNS(SVG, 'svg');
    svg.setAttribute('class', classe || 'labo-card__icon');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '2');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    svg.innerHTML = ICONES[nom];
    return svg;
  }

  function element(balise, classe, texte) {
    var e = document.createElement(balise);
    if (classe) e.className = classe;
    if (texte) e.textContent = texte;
    return e;
  }

  /* « Mer. 21 oct. · 17h », « Sam. 24 oct. · 10h30 ». */
  function libelle(seance) {
    var p = seance.jour.split('-');
    // Midi UTC : le jour reste le même quel que soit le fuseau d'affichage.
    var d = new Date(Date.UTC(+p[0], +p[1] - 1, +p[2], 12));
    var jour = new Intl.DateTimeFormat('fr-FR', {
      weekday: 'short', day: 'numeric', month: 'short', timeZone: FUSEAU
    }).format(d);
    var hm = seance.heure.split(':');
    var heure = parseInt(hm[0], 10) + 'h' + (hm[1] === '00' ? '' : hm[1]);
    return jour.charAt(0).toUpperCase() + jour.slice(1) + ' · ' + heure;
  }

  function pastille(restantes) {
    if (restantes === 0) return { classe: 'full', texte: 'Complet', icone: 'interdit' };
    if (restantes >= 5) return { classe: 'ok', texte: restantes + ' places', icone: 'personnes' };
    if (restantes >= 2) return { classe: 'low', texte: 'Reste ' + restantes + ' places', icone: 'personnes' };
    return { classe: 'last', texte: 'Dernière place', icone: 'personnes' };
  }

  /* Pose la clé que l'app lit pour ouvrir son calendrier sur une séance. */
  function preparerOuverture(eventId, seance) {
    if (!seance || !seance.debut) return;
    try {
      localStorage.setItem(CLE_OUVERTURE, JSON.stringify({
        value: JSON.stringify({ eventId: eventId, start: seance.debut }),
        expiry: Date.now() + OUVERTURE_MS
      }));
    } catch (e) { /* stockage bloqué : la fiche s'ouvre sans présélection */ }
  }

  function ligne(seance, donnees, url, demo) {
    var complete = seance.restantes === 0;
    var li = element('li', 'labo-card__slot' + (complete ? ' is-full' : ''));
    var cible;
    if (complete) {
      cible = element('div', 'labo-card__slot-link');
      cible.setAttribute('aria-disabled', 'true');
    } else {
      cible = element('a', 'labo-card__slot-link');
      cible.href = url;
      cible.addEventListener('click', function () { preparerOuverture(donnees.eventId, seance); });
    }

    var date = element('span', 'labo-card__slot-date');
    date.appendChild(icone('calendrier'));
    date.appendChild(element('span', null, libelle(seance)));
    cible.appendChild(date);

    if (!demo && seance.restantes !== null) {
      var p = pastille(seance.restantes);
      var badge = element('span', 'labo-card__badge labo-card__badge--' + p.classe);
      badge.appendChild(icone(p.icone));
      badge.appendChild(element('span', null, p.texte));
      cible.appendChild(badge);
    } else if (complete) {
      cible.appendChild(element('span', 'sr-only', 'Complet'));
    }

    li.appendChild(cible);
    return li;
  }

  function texteTiroir(n) {
    return '+ ' + n + (n > 1 ? ' autres dates' : ' autre date');
  }

  var compteurTiroir = 0;

  function construireListe(conteneur, donnees, url, demo) {
    var seances = donnees.seances;
    var visibles = element('ul', 'labo-card__slots');
    seances.slice(0, LIGNES_VISIBLES).forEach(function (s) {
      visibles.appendChild(ligne(s, donnees, url, demo));
    });
    conteneur.textContent = '';
    conteneur.appendChild(visibles);

    var reste = seances.slice(LIGNES_VISIBLES);
    if (!reste.length) return;

    var id = 'labo-card-more-' + (++compteurTiroir);
    var tiroir = element('div', 'labo-card__more');
    tiroir.id = id;
    var interieur = element('div', 'labo-card__more-inner');
    var suite = element('ul', 'labo-card__slots');
    reste.forEach(function (s) { suite.appendChild(ligne(s, donnees, url, demo)); });
    interieur.appendChild(suite);
    tiroir.appendChild(interieur);
    tiroir.setAttribute('inert', '');            // fermé : ni focus ni lecteur d'écran

    var bouton = element('button', 'labo-card__toggle');
    bouton.type = 'button';
    bouton.setAttribute('aria-expanded', 'false');
    bouton.setAttribute('aria-controls', id);
    var libelleBouton = element('span', null, texteTiroir(reste.length));
    bouton.appendChild(libelleBouton);
    bouton.appendChild(icone('chevron', 'labo-card__chevron'));
    bouton.addEventListener('click', function () {
      var ouvert = bouton.getAttribute('aria-expanded') !== 'true';
      bouton.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
      tiroir.classList.toggle('is-open', ouvert);
      if (ouvert) tiroir.removeAttribute('inert'); else tiroir.setAttribute('inert', '');
      libelleBouton.textContent = ouvert ? 'Masquer les dates' : texteTiroir(reste.length);
    });

    conteneur.appendChild(tiroir);
    conteneur.appendChild(bouton);
  }

  function marquerComplet(carte) {
    var cta = carte.querySelector('.labo-card__cta');
    if (!cta) return;
    cta.classList.add('is-full');
    cta.removeAttribute('href');
    cta.removeAttribute('data-instant');
    cta.setAttribute('aria-disabled', 'true');
    cta.textContent = 'Complet';
  }

  function remplir(carte, donnees) {
    if (!donnees || !donnees.seances || !donnees.seances.length) return;

    var conteneur = carte.querySelector('.labo-card__dates');
    if (!conteneur) return;
    var url = carte.getAttribute('data-product-url') || '#';
    var demo = carte.hasAttribute('data-demo');

    construireListe(conteneur, donnees, url, demo);
    conteneur.hidden = false;

    var disponibles = donnees.seances.filter(function (s) { return s.restantes !== 0; });
    if (!disponibles.length) { marquerComplet(carte); return; }

    // « Réserver » vise la première séance disponible.
    var cta = carte.querySelector('.labo-card__cta');
    if (cta && !cta.classList.contains('is-full')) {
      cta.addEventListener('click', function () { preparerOuverture(donnees.eventId, disponibles[0]); });
    }
  }

  function traiter(racine) {
    var cartes = (racine.querySelectorAll ? racine : document)
      .querySelectorAll('.labo-card[data-product-id]:not([data-labo-vu])');
    Array.prototype.forEach.call(cartes, function (carte) {
      carte.setAttribute('data-labo-vu', '');
      var pid = carte.getAttribute('data-product-id');
      var vid = carte.getAttribute('data-variant-id');
      if (!pid || !vid) return;
      charger(pid, vid).then(function (donnees) {
        try { remplir(carte, donnees); } catch (e) { /* muet : la carte reste utilisable */ }
      });
    });
  }

  function demarrer() {
    try { traiter(document); } catch (e) { return; }

    /* Cartes injectées plus tard : filtres de collection, recherche prédictive,
     * produits liés et vus récemment (chargés en différé par le thème).
     * Une seule passe par frame : l'app de réservation et le MODULE 1 modifient
     * le DOM en rafale, et la passe ne coûte qu'un querySelectorAll. */
    var prevu = false;
    new MutationObserver(function () {
      if (prevu) return;
      prevu = true;
      requestAnimationFrame(function () {
        prevu = false;
        try { traiter(document); } catch (e) { /* muet */ }
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
